/* ============================================================
   Ecospeed Pro — theme.js
   ============================================================ */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-slideshow-dot]');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var idx = 0;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      reset();
    }
    function reset() {
      if (autoplay) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () { go(idx + 1); }, speed);
      }
    }

    var prev = root.querySelector('[data-slideshow-prev]');
    var next = root.querySelector('[data-slideshow-next]');
    if (prev) prev.addEventListener('click', function () { if (timer) clearTimeout(timer); go(idx - 1); });
    if (next) next.addEventListener('click', function () { if (timer) clearTimeout(timer); go(idx + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        if (timer) clearTimeout(timer);
        go(parseInt(d.dataset.slideshowDot, 10));
      });
    });
    reset();
  });

  /* ---------- Toast ---------- */
  var toastEl = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Cart count ---------- */
  function updateCartCount() {
    if (!routes.cart) return;
    fetch(routes.cart + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], [data-cart-count-mobile]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (JS enhancement, falls back to normal POST) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.querySelector('span') : null;
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';
    fetch(routes.cartAdd, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (label) label.textContent = original;
        showToast('Added to cart');
        updateCartCount();
      })
      .catch(function () {
        if (label) label.textContent = original;
        showToast('Could not add — please try again');
      });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    function set(v) {
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = 1;
      input.value = Math.max(parseInt(input.min, 10) || 1, val + v);
      input.dispatchEvent(new Event('change'));
    }
    if (minus) minus.addEventListener('click', function () { set(-1); });
    if (plus) plus.addEventListener('click', function () { set(1); });
  });

  /* ---------- Cart: quantity change / remove auto-submit ---------- */
  document.querySelectorAll('[data-cart-qty-form]').forEach(function (form) {
    var input = form.querySelector('[data-qty-input]');
    if (!input) return;
    input.addEventListener('change', function () { form.submit(); });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.closest('[data-cart-line]');
      var form = line ? line.querySelector('[data-cart-qty-form]') : null;
      if (!form) return;
      var input = form.querySelector('[data-qty-input]');
      if (input) input.value = 0;
      form.submit();
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('.product-gallery__img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.full) {
          mainImg.src = thumb.dataset.full;
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
        }
      });
    });
  }

  /* ---------- Variant selection (single-select options) ---------- */
  var variantJson = document.querySelector('[data-variant-json]');
  var variantInput = document.querySelector('[data-variant-id]');
  if (variantJson && variantInput) {
    var variants = JSON.parse(variantJson.textContent);
    var priceMap = {};
    var priceJson = document.querySelector('[data-variant-prices]');
    if (priceJson) {
      JSON.parse(priceJson.textContent).forEach(function (p) { priceMap[p.id] = p; });
    }
    var selects = document.querySelectorAll('[data-variant-option]');
    var submitBtn = variantInput.closest('form') ? variantInput.closest('form').querySelector('button[type="submit"]') : null;
    var btnSpan = submitBtn ? submitBtn.querySelector('span') : null;
    var priceWrapper = document.querySelector('[data-price-wrapper]');

    function update() {
      var key = Array.from(selects).map(function (s) { return s.value; }).join(' / ');
      var v = variants.find(function (x) {
        return [x.option1, x.option2, x.option3].filter(Boolean).join(' / ') === key;
      });
      if (!v) return;
      variantInput.value = v.id;
      if (submitBtn) submitBtn.disabled = !v.available;
      if (btnSpan) btnSpan.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceWrapper && priceMap[v.id]) {
        var current = priceWrapper.querySelector('.price--current');
        var compare = priceWrapper.querySelector('.price--compare');
        var badge = priceWrapper.querySelector('.badge--sale');
        if (current) current.textContent = priceMap[v.id].price;
        if (compare) {
          if (priceMap[v.id].compare && priceMap[v.id].compare !== priceMap[v.id].price) {
            compare.textContent = priceMap[v.id].compare;
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
        if (badge) badge.style.display = (compare && compare.style.display === '') ? '' : 'none';
      }
    }
    selects.forEach(function (sel) { sel.addEventListener('change', update); });
  }

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('[data-sort-form]');
      if (form) form.submit();
    });
  });

  /* ---------- Product recommendations ---------- */
  var recSection = document.querySelector('[data-recommendations-section]');
  if (recSection && recSection.dataset.url) {
    fetch(recSection.dataset.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var container = recSection.querySelector('[data-recommendations-container]');
        var fetched = doc.querySelector('[data-recommendations-container]');
        if (container && fetched && fetched.innerHTML.trim()) {
          container.innerHTML = fetched.innerHTML;
        } else {
          recSection.remove();
        }
      })
      .catch(function () { recSection.remove(); });
  }
})();
